import {CALL_API} from 'middleware/api';
import {TRANSFORM} from 'middleware/transform';
import * as ActionTypes from '../PreMatchMenu';

export function initPreMatchMenu(data) {
    const {languageId} = data;
    return (dispatch) => {
        return dispatch({
                type: ActionTypes.INIT_PREMATCH_MENU,
                [CALL_API]: {
                    endpoint: `/api/menu?languageId=${languageId}`,
                    method: 'get',
                    types: [
                        ActionTypes.SUCCESS_INIT_PREMATCH_MENU,
                        ActionTypes.FAILURE_INIT_PREMATCH_MENU
                    ],
                    data
                },
                [TRANSFORM]: {
                    section: 'menu',
                    transformType: 'init',
                    provider: (data) => data
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/PreMatchMenu.js